import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-14 h-14 mx-auto text-muted-foreground" />
      <h1 className="mt-5 text-2xl font-display font-black tracking-tight">Payment cancelled</h1>
      <p className="mt-2 text-muted-foreground">No payment was taken. Your basket is still saved if you'd like to try again.</p>
      <div className="mt-8 flex gap-3 justify-center">
        <Link to="/checkout" className="bg-primary text-white px-6 py-3 rounded-sm font-semibold hover:bg-primary/90">Return to checkout</Link>
        <Link to="/cart" className="border border-border px-6 py-3 rounded-sm font-semibold hover:bg-muted">View basket</Link>
      </div>
    </div>
  );
}
